<div class="main-layout flex flex-column">
  <app-partner-style *ngIf="partnerBrandService.data.partner && partnerBrandService.data.partner.brand"></app-partner-style>

  <div class="error-content text-center margin-top-xxbig flex-grow">
    <div class="flex flex-justify-center">
      <open-svg-icon name="500" class="medium margin-top-medium margin-bottom-large"></open-svg-icon>
    </div>

    <h1 class="margin-bottom-medium">Oops! That is not allowed...</h1>

    <p class="text-small">You've asked for something and we can't understand you.</p>

    <p class="text-small">Error type: 401</p>
  </div>
  <app-footer class="open-footer" [partnerBrandData]="partnerBrandService.data.partner"></app-footer>
</div>
